import React from 'react';
import { Menu } from '@teetsh/app/src/components/Menu';

export function MenuItemsLoader() {
  return (
    <>
      {[1, 2, 3].map(i => (
        <Menu.Item key={i} loading />
      ))}
    </>
  );
}
